module.exports = "<header class=\"bordered\">\n  <a onclick=\"window.history.back()\" class=\"back\"><span class=\"icon blue x-small left\"></span> Back</a>\n  <h6 class=\"grow\">Which light would you like to trigger this automation?</h6>\n  <button class=\"default clickabke\" (click)=\"goHome()\">Cancel</button>\n</header>\n<prg-select-light rowClass=\"dark\" (selected)=\"lightSelected($event)\"></prg-select-light>\n"


//////////////////
// WEBPACK FOOTER
// ./~/@c4/programming/src/app/quickstarts/quickstart-lights/light-trigger/light-trigger.component.html
// module id = 1574
// module chunks = 2